import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'

export const canActivateSignin: CanActivateFn = () => {
  const router = inject(Router)

  // Prevent navigating to signin (via browser forward) without counselling mode selected
  const counsellingMode = localStorage.getItem('counsellingMode')
  if (!counsellingMode) {
    router.navigateByUrl('/')
    return false
  }
  return true
}
